import { IconButton } from "@chakra-ui/react";
import { TableViewCreateOrUpdateModal } from "features/transactions/TableViewCreateOrUpdateModal/TableViewCreateOrUpdateModal";
import {
  getTableViewGetQueryKey,
  getTableViewsGetQueryKey,
} from "gen/endpoints/table-views/table-views";
import { TableParamsTypeEnum } from "gen/model/tableParamsTypeEnum";
import { TableViewReadData } from "gen/model/tableViewReadData";
import { Edit2Icon } from "shared/icons/Edit2Icon";
import { useInvalidateQueryKeys } from "shared/utils/QueryUtils";
import { useBoolean } from "usehooks-ts";

export const EditCell = ({ view }: { view: TableViewReadData }) => {
  const {
    value: isEditModalOpen,
    setTrue: openEditModal,
    setFalse: closeEditModal,
  } = useBoolean();
  const invalidateQuery = useInvalidateQueryKeys();

  const onEdit = async () => {
    if (view.id) {
      await invalidateQuery(
        getTableViewsGetQueryKey(),
        getTableViewGetQueryKey(view.id),
      );
    }
  };

  return (
    <>
      <IconButton
        onClick={(e) => {
          // we dont want this to trigger a row click here cuz we want it to only open the modal
          e.preventDefault();
          openEditModal();
        }}
        variant="ghostDarken"
        aria-label="Edit"
        icon={<Edit2Icon />}
      />
      <TableViewCreateOrUpdateModal
        existingViewId={view.id}
        viewDetails={view}
        isOpen={isEditModalOpen}
        onClose={closeEditModal}
        viewType={TableParamsTypeEnum.transaction_table}
        onSuccess={onEdit}
        getViewState={() => view.encoded_table_params}
      />
    </>
  );
};
